import { Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';

const TopSection = ({ selected, setSelected }) => {
  const { t } = useTranslation();

  const options = [
    {
      icon: 'throphy',
      text: t('common.team')
    },
    {
      // Athlete shoutouts aren't available from this flow yet — shown but
      // not selectable, so the tab still communicates it exists.
      icon: 'athletes',
      text: t('common.athlete'),
      disabled: true
    }
  ];

  return (
    <Row center wid="100%" gap="24px">
      {options.map(
        (x, i) =>
          x && (
            <Clickable
              key={x.icon}
              onClick={x.disabled ? undefined : () => setSelected(i)}
              disabled={x.disabled}
            >
              <Col centerAll wid="141px">
                <Row noFlex wid="32px" ht="32px" centerAll>
                  <Icon
                    type={x.icon}
                    dimensions={x.iconDimensions || 22}
                    col={
                      x.disabled ? theme.GREY_20 : selected === i ? theme.SECONDARY : theme.GREY_30
                    }
                  />
                </Row>
                <Text
                  b1
                  bold
                  marg="6px 0 0"
                  col={
                    x.disabled ? theme.GREY_20 : selected === i ? theme.SECONDARY : theme.GREY_60
                  }
                >
                  {x.text}
                </Text>
              </Col>
            </Clickable>
          )
      )}
    </Row>
  );
};

export default TopSection;
